// Compares the running native-app version (set by _js.slim from the parsed
// User-Agent) against a required minimum. Returns false outside the native
// app, when the version is missing, or when either string isn't a three-part
// numeric `x.y.z`.
;(() => {
  function parseVersion(value) {
    if (typeof value !== "string" || !value) return null
    const parts = value.split(".").map((part) => Number(part))
    if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) {
      return null
    }
    return parts
  }

  function nativeAppVersionAtLeast(required) {
    const current = parseVersion(window.nativeAppVersion)
    const minimum = parseVersion(required)
    if (!current || !minimum) return false
    for (let i = 0; i < 3; i += 1) {
      if (current[i] > minimum[i]) return true
      if (current[i] < minimum[i]) return false
    }
    return true
  }

  function postMessageForVersion(payload, requiredVersion) {
    if (!nativeAppVersionAtLeast(requiredVersion)) return
    window.ReactNativeWebView?.postMessage?.(JSON.stringify(payload))
  }

  window.HB = window.HB || {}
  window.HB.nativeAppVersionAtLeast = nativeAppVersionAtLeast
  window.HB.postMessageForVersion = postMessageForVersion
})()
